import * as angular from "angular";
import {DataHubService} from "../modules/DataHubModule";
import {IComponentController} from "angular";
import {QbPriceLevelDto} from "../model/QbPriceLevelDto";
import {DisposeBag} from "../modules/DisposeBag";

class QbPriceLevelSelectController implements IComponentController {
    records: QbPriceLevelDto[] = [];
    model: any;
    onSelect: Function;
    required: string;
    placeholder: string;
    showAll: Boolean;
    private disposeBag = new DisposeBag();

    constructor(private $dataHub: DataHubService, private $scope) {
        $dataHub.bindAllQbPriceLevel(() => this.records, this.disposeBag);
        $dataHub.onConnected(this.reload, this.disposeBag);
    }

    reload = () => {
        this.$dataHub.qbPriceLevelSubscribeAndQuery().then(ret => this.records = ret);
    };

    $onInit(): void {
    }

    $onDestroy?() {
        this.disposeBag.finalize();
    }
    filter(value: QbPriceLevelDto): boolean {
        if(this.showAll) return true;
        if(this.model.guid==value.guid) return true;
        return value.isActive;
    }


}

export default angular.module('component.qbPriceLevelSelect', [])
    .component('qbPriceLevelSelect', {
        template: require('./QbPriceLevelSelect.html'),
        controller: QbPriceLevelSelectController,
        bindings: {
            model: '=',
            onSelect: '&',
            required: '=',
            placeholder: '@',
            showAll: '=',
            allowClear: '='
        }
    }).name;
